import React from 'react';
import SubscriptionIndex from 'pages/builder/subscriptions/subscription_index';
import { AppUI } from '@seedlang/state';
import { autorun } from 'mobx';

class SiteSubscriptionIndex extends React.Component {

  constructor(props) {
    super(props);
    this.disposer = autorun(() => {
      if (AppUI.userIsLoaded && !AppUI.user.guest && !AppUI.permissions.canAccessBasicUserData) {
        AppUI.routeStore.routeToNamed('creator.worksheets.index');
      }
    });
  }

  componentWillUnmount() {
    this.disposer && this.disposer();
  }

  render() {
    return (
      <SubscriptionIndex
        {...this.props}
        whiteLabeled
      />
    );
  }
}

export default SiteSubscriptionIndex;
